import { render } from "./PageSidebar.vue?vue&type=template&id=543649a0"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=543649a0&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__